// Traducciones en inglés para la sección "Quiénes somos"
const whoweare = {
  whoweare: "ABOUT US",
  whoweareText0:
    "Have you not heard of Zaquiel? That's normal. After all, it's the first time we're paying attention to him.",
  whoweareText1:
    "Besides, he himself isn't quite sure who he is yet, so… let's follow him and see where he takes us to *The Valley of Silence*, in El Bierzo.",
  whoweareText2:
    "This comic is part of the project 'Research on Digital Comics for the Dissemination of the Cultural Heritage of Castile and León' (ICDIDIPACU) by UEMC, under the 'Call for Grants for the Conservation and Promotion of the Architectural and Cultural Heritage of Castile and León,' funded by the Castile and León Foundation.",
  whoweareText3: "Legal deposit: DL VA 137-2024",
  whoweareTitle: "Presenting a new saga of adventures!",
  whoweareAuthors: "Authors"
}; 

export default whoweare; 